import { render, staticRenderFns } from "./Roughness.vue?vue&type=template&id=86c5e0d4"
import script from "./Roughness.vue?vue&type=script&lang=js"
export * from "./Roughness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports